import { firebaseMutations, firebaseAction } from 'vuexfire'
import firebaseApp from './../firebase-setup'
import * as getterConstants from './getterConstants'
const db = firebaseApp.database()

const organizationNameKeyRef = db.ref('_meta/namekeys/organizations')

export const organizationsModule = {
  namespaced: true,
  state: {
    organizationNameKeys: {}
  },
  mutations: {
    ...firebaseMutations
  },
  actions: {
    // [getterConstants.SET_DEFAULT_USER_INFO]: firebaseAction((context, value) => {
    //   const setEmailRegistRef = db.ref('users')
    //   setEmailRegistRef.set(value)
    // }),
    [getterConstants.GET_ORGANIZATION_NAME_KEY]: firebaseAction(({ bindFirebaseRef }) => {
      // console.log('bind:getterConstants.GET_GROUP_NAME_KEY')
      bindFirebaseRef('organizationNameKeys', organizationNameKeyRef, { wait: true })
    }),
    [getterConstants.SET_FOLLOWING_ORGANIZATIONS]: firebaseAction((context, value) => {
      const currentUserId = context.rootState.currentUserId
      const setFollowingGroupsRef = db.ref('users/' + currentUserId + '/following/groups')
      if (value.oldFollowingOrganizations) {
        for (let key in value.oldFollowingOrganizations) {
          // console.log(value[key])
          setFollowingGroupsRef.child(value.oldFollowingOrganizations[key]).remove()
        }
      }
      if (value.organizations) {
        for (let key in value.organizations) {
          setFollowingGroupsRef.child(value.organizations[key]).set(1)
        }
      }
    })
  },
  getters: {
    getGroups: (state, getters, rootState) => {
      console.log('rootstate', rootState)
      return rootState.groups.groups
    },
    getOrganizationNameKeys: state => state.organizationNameKeys,
    getCurrentGroups: (state, getters, rootState) => rootState.groups.currentGroups,
    getOnlyOrganizationsByIds: (state, getters) => organizationIds => {
      let organizations = {root: {}, node: {}}
      for (let organizationId of organizationIds) {
        if (getters.getGroups[organizationId] && getters.getGroups[organizationId].hasOwnProperty('isOrganization')) {
          organizations['node'][organizationId] = getters.getGroups[organizationId]
          if (!getters.getGroups[organizationId].hasOwnProperty('parentGroup')) {
            organizations['root'][organizationId] = getters.getGroups[organizationId]
          }
        }
      }
      return organizations
    },
    getOnlyOrganizationsById: (state, getters) => organizationId => {
      if (getters.getGroups[organizationId] && getters.getGroups[organizationId].hasOwnProperty('isOrganization')) {
        return getters.getGroups[organizationId]
      } else {
        return { 'notOrganization': true, 'isInactive': true }
      }
    },
    getOrganizationExpansion: (state, getters) => organizationId => {
      // organizationをもらって展開(expansion)して返す
      // ex: x{childGroups: [a,b,c]} => [x,a,b,c]
      let org = [...organizationId]
      let targetOrganizationId
      let stack = [organizationId]
      while (stack.length > 0) {
        targetOrganizationId = stack.pop()
        if (getters.getGroups[targetOrganizationId].hasOwnProperty('childGroups')) {
          stack.push(...Object.keys(getters.getGroups[targetOrganizationId].childGroups))
          org.push(...Object.keys(getters.getGroups[targetOrganizationId].childGroups))
        }
      }
      return org
    },
    getOrganizationRoots: (state, getters) => organizationIds => {
      // organizationsを貰ってその中で独立されている限りの木のrootを返す
      // ex: x{childGroups: [a,b]},a{childGroups: [c,d]},y{childGroups: []} => [x,y]
      let orgs = {}
      let rootOrgs = []
      const stateGroups = getters.getGroups
      for (let orgId of organizationIds) {
        // 存在する親を見つける時にハッシュ探索じゃないと苦しいので
        orgs[orgId] = true
      }
      for (let orgId of organizationIds) {
        let checkRoot = true
        let targetOrg = orgId
        while (true) {
          if (!stateGroups[targetOrg].hasOwnProperty('parentGroup')) {
            break
          } else if (orgs.hasOwnProperty(stateGroups[targetOrg]['parentGroup'])) {
            checkRoot = false
            break
          } else {
            targetOrg = stateGroups[targetOrg]['parentGroup']
          }
        }
        if (checkRoot) {
          rootOrgs.push(orgId)
        }
      }
      return rootOrgs
    },
    getOpenOrganization: (state, getters) => groupIds => {
      let hierarchy = {} // 階層ごとに分ける //重複処理
      let childOpens = {} // return用
      const stateGroups = getters.getGroups
      let deepest = groupIds // 最深部候補は必ず検索対象ここから削る
      for (let openRoute of groupIds) {
        // openRouteは検索対象
        let route = []
        route.push(openRoute)
        let parent = openRoute
        let check = false
        do {
          check = false
          if (!!stateGroups[parent] && stateGroups[parent].hasOwnProperty('parentGroup') && !(stateGroups[parent].hasOwnProperty('isInactive') && stateGroups[parent]['isInactive'])) {
            parent = stateGroups[parent].parentGroup
            check = true
            route.unshift(parent)
          }
        } while (parent !== 'root' && check)
        deepest = deepest.filter(x => (!route.includes(x)))
        if (!deepest.includes(route[route.length - 1])) {
          deepest.push(route[route.length - 1])
        }
        let routeindex = 0
        let pushroute = !(hierarchy.hasOwnProperty('0'))
        if (pushroute !== true) { // 初回じゃなければ
          for (let floor of Object.values(hierarchy)) {
            if (floor && !!hierarchy[String(routeindex)][route[routeindex]]) {
              routeindex += 1
              continue
            }
          }
        }
        let rootKey = route[0]
        if (!childOpens.hasOwnProperty(rootKey)) {
          childOpens[rootKey] = {node: [], depth: 0}
        }
        if (routeindex === 0) {
          childOpens[rootKey]['node'].push(route[routeindex])
        }
        while (route.length > routeindex) {
          if (!hierarchy[String(routeindex)]) {
            hierarchy[String(routeindex)] = {}
          }
          if (childOpens[rootKey]) {
            childOpens[rootKey]['node'].push(route[routeindex])
            if (childOpens[rootKey]['depth'] < routeindex) {
              // 最深部更新
              childOpens[rootKey]['depth'] = routeindex
            }
          }
          hierarchy[String(routeindex)][route[routeindex]] = true
          routeindex += 1
        }
      }
      for (let floor of Object.keys(childOpens)) {
        if (childOpens[floor]['node']) {
          // 最終尾は開閉処理必要なし
          childOpens[floor]['node'] = childOpens[floor]['node'].filter(x => !deepest.includes(x))
        }
      }
      return childOpens
    },
    getCurrentTree: (state, getters) => {
      const stateGroups = getters.getGroups
      const stateCurrentGroups = getters.getCurrentGroups
      let k = getters.getOnlyOrganizationsByIds(Object.keys(stateCurrentGroups))
      let c = getters.getOpenOrganization(Object.keys(k['node']))
      let t = Object.keys(c)
      let tc = c[t]
      console.log('stateGroupshieraruchy', k, c, c['node'])
      if (tc && tc.hasOwnProperty('node')) {
        for (let r of tc['node']) {
          console.log('stateGroups:test', stateGroups[r])
        }
      }
      console.log('currentTree:', tc, c)
      return c
    },
    getOnlyOrganizationsByText: (state, getters) => text => {
      let organizations = {}
      const regexp = new RegExp(text, 'i')
      const stateGroups = getters.getGroups
      for (let group in stateGroups) {
        if (!stateGroups[group].groupName || !stateGroups[group].hasOwnProperty('isOrganization')) {
          continue
        }
        if (stateGroups[group].groupName.match(regexp)) {
          organizations[group] = stateGroups[group]
        }
      }
      return organizations
    },
    getChildTreeDepth: (state, getters) => groupId => {
      const stateGroups = getters.getGroups
      let depth = 0
      let que = []
      let childGroupLength = 0
      let childGroupLengthNext = 0
      let first = true
      que.push(stateGroups[groupId])
      do {
        // que階層情報を得るためにchildGroupの情報を得て深さを得る
        // イメージ的には反復深化探索
        let group = que.shift()
        if (!first) {
          if (childGroupLength <= 0) {
            childGroupLength = childGroupLengthNext
            childGroupLengthNext = 0
            depth += 1
          }
          childGroupLength -= 1
        } else {
          first = false
        }
        let childlength = 0
        if (group.hasOwnProperty('childGroups')) {
          for (let child of Object.keys(group.childGroups)) {
            if (stateGroups[child].hasOwnProperty('isInactive')) {
              continue
            }
            que.push(stateGroups[child])
            childlength += 1
          }
          childGroupLengthNext += childlength
        }
      } while (que.length > 0)
      console.log('childDepth:', depth)
      return depth
    },
    getOrganizationCSV: (state, getters) => {
      const groups = getters.getGroups
      const organizations = getters.getOnlyOrganizationsByIds(Object.keys(groups))
      const organizationNameKeys = getters.getOrganizationNameKeys
      let csv = ''
      for (let root of Object.keys(organizations['root'])) {
        let stack = []
        let targetOrg = groups[root]
        let targetId = root
        do {
          // stack(深さ優先)
          if (!!targetOrg && targetOrg.hasOwnProperty('childGroups')) {
            const children = []
            for (let child of Object.keys(targetOrg.childGroups)) {
              children.push(child)
            }
            stack.unshift(...children)
          }
          if (!!organizationNameKeys && organizationNameKeys.hasOwnProperty(targetId)) {
            csv = csv + organizationNameKeys[targetId].replace(/\//g, ',') + '\r\n'
          }
          if (stack.length > 0) {
            targetId = stack.shift()
            targetOrg = groups[targetId]
          } else {
            break
          }
        } while (true)
      }
      return csv
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/organizations.js